module.exports = __webpack_public_path__ + "img/success.ba9e6048.png";